import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';

import { BillReceivableService } from 'src/app/services/bill-receivable.service';
import { SalesService } from 'src/app/services/sales.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ProductService } from 'src/app/services/product.service';
import { getStringDate } from 'src/app/common/util';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { CreditNoteResponse } from 'src/app/models/invoice.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-billr-downnote',
  templateUrl: './billr-downnote.component.html',
  styleUrls: ['./billr-downnote.component.scss']
})
export class BillrDownnoteComponent {

  client = new InputAutocompleteModel('', false, false, '', 'loading', '', '', null, []);
  clients: any[] = [];
  filterClients: any[] = [];
  clientSelected: any = null;

  invoices: any[] = [];
  invoicesData: any[] = [];
  selectedInvoice: any | null = null;

  loadingClients = false;
  loadingInvoices = false;

  timeout = null;

  creditNoteDate = getStringDate(new Date());
  creditNoteDescription = "";

  creditType: 'discount' | 'return' | null = null;
  filterWord: string = null;

  setCreditType(type: 'discount' | 'return') {
    this.creditType = type;

    if (type === 'return') {
      this.autoFillReturnProducts();
    }

    if (type === 'discount') {
      this.productsList = [];
    }
  }


  inputs = {
    product: new InputAutocompleteModel('', false, false, '', 'loading', '', '', null, [])
  };

  selectedProduct: ProductResponse | null = null;
  products: ProductResponse[] = [];
  filterProducts: ProductResponse[] = [];

  quantity = 0;
  unitPrice = 0;
  lineTotal = 0;

  productsList: any[] = [];

  invoiceDetails: any[] = [];
  isLoadingDetails: boolean = false;

  currentCompany: any = null;

  ncreQuantity: any = {
    quantity: 0,
    total: 0
  };

  loadingNcreQuantity = false;

  constructor(
    private vendorService: VendorService,
    private billRecService: BillReceivableService,
    private toastService: ToastrService,
    private saleService: SalesService,
    private productService: ProductService,
    private createService: TemplateInvoice,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    this.getInitVendors();
    this.getProducts("");
    this.currentCompany = JSON.parse(this.authService.getCurrentCompany());
  }

  getInitVendors(): void {
    this.loadingClients = true;
    this.vendorService.getClientsByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.clients = response.data;
        this.client.filterElements = this.clients;
        this.client.class = 'fa-list';
        this.loadingClients = false;
      },
      error: () => {
        this.toastService.error('No se pudieron cargar los clientes');
        this.loadingClients = false;
      }
    });
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";

    const clue = (this.client.value ?? "").trim();

    this.timeout = setTimeout(() => {
      this.client.class = "loading";

      this.vendorService.getClientsByClue(clue).subscribe({
        next: (resp: ResponseObject) => {
          const raw = Array.isArray(resp.data) ? resp.data : [];
          this.client.filterElements = raw;

          if (raw.length === 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
            this.client.required = false;
          }
        },
        error: () => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error(`Error al obtener clientes "${clue}"`);
        }
      });
    }, 500);
  }

  selectClient(client: any): void {
    this.clientSelected = client;
    this.selectedInvoice = null;
    this.invoices = [];
    this.ncreQuantity = {
      quantity: 0,
      total: 0
    };

    if (!client?.id) return;
    this.cleanForms();

    this.loadClientInvoices(client.id);
  }

  loadClientInvoices(clientId: number): void {
    this.loadingInvoices = true;

    this.billRecService.getBillsIn(clientId).subscribe({
      next: (response: ResponseObject) => {
        this.invoices = response.data?.clientInvoices ?? [];
        this.invoicesData = response.data?.clientInvoices ?? [];
        if (this.invoices.length === 0) {
          this.toastService.info('El cliente no tiene facturas aplicables');
        }
        this.loadingInvoices = false;
      },
      error: () => {
        this.toastService.error('No se pudieron cargar las facturas');
        this.invoices = [];
        this.invoicesData = [];
        this.loadingInvoices = false;
      }
    });
  }

  onInvoiceSelected(invoice: any): void {
    this.selectedInvoice = invoice;

    this.ncreQuantity = {
      quantity: 0,
      total: 0
    };

    this.loadInvoiceDetail(invoice);
    this.loadNcreToInvoice(invoice);
  }

  getInvoiceAmount(inv: any): number {
    const extra = inv.totalExtraTax ?? 0;
    return (inv.totalCost || 0) + (inv.totalTaxes || 0) + extra;
  }

  getCurrencyPrefix(inv: any): string {
    return inv.currency === 1 ? '$. ' : 'Q. ';
  }

  loadInvoiceDetail(invoice) {
    this.isLoadingDetails = true;

    this.saleService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.invoiceDetails = response.data || [];
        this.isLoadingDetails = false;

        if (this.creditType === "return") {
          this.autoFillReturnProducts();
        }
      },
      error: () => {
        this.toastService.error("Error al obtener detalle de la factura");
        this.isLoadingDetails = false;
      }
    });
  }

  loadNcreToInvoice(invoice: any): void {
    if (!invoice?.id) {
      return;
    }

    this.loadingNcreQuantity = true;

    this.billRecService.getNcreQuantity(invoice.id).subscribe({
      next: (response: ResponseObject) => {
        this.ncreQuantity = response.data ?? {
          quantity: 0,
          total: 0
        };

        this.loadingNcreQuantity = false;
      },
      error: () => {
        this.ncreQuantity = {
          quantity: 0,
          total: 0
        };

        this.loadingNcreQuantity = false;
        this.toastService.error("Error al obtener cantidad de ncres asignadas a la factura");
      }
    });
  }

  autoFillReturnProducts() {
    this.productsList = this.invoiceDetails.map(d => {
      const unitPrice = d.price + d.taxes;
      return {
        product: d.productData,
        quantity: d.quantity,
        unitPrice: unitPrice,
        total: unitPrice * d.quantity
      };
    });

    this.toastService.info("Productos agregados automáticamente por devolución.");
  }

  removeProduct(index: number) {
    this.productsList.splice(index, 1);
  }



  submitCreditNote() {
    if (!this.creditType) {
      this.toastService.warning("Seleccione el tipo de Nota de Crédito.");
      return;
    }

    const payload = this.buildCreditNotePayload();

    if (!payload) {
      return;
    }

    console.log("PAYLOAD: ");
    console.log(payload);

    this.billRecService.createCreditNote(payload).subscribe({
      next: (response: ResponseObject) => {
        const creditData = response.data;
        this.toastService.success("Nota de crédito generada correctamente");
        this.createCreditNotePDF(creditData);
        this.cleanForms();
      },
      error: () => {
        this.toastService.error("Error al generar la nota de crédito");
      }
    });
  }

  cleanForms(){
    this.productsList = [];
    this.selectedInvoice = null;
    this.invoiceDetails = [];
    this.creditType = null;
    this.creditNoteDescription = "";
  }


  buildCreditNotePayload() {

    if (!this.clientSelected || !this.selectedInvoice) {
      this.toastService.warning("Seleccione cliente y factura antes de continuar.");
      return null;
    }

    const amount = this.getInvoiceAmount(this.selectedInvoice);

    return {
      invoice: this.selectedInvoice.id,
      invoiceList: [
        {
          invoice: this.selectedInvoice.id,
          amount: amount,
          type: 0
        }
      ],

      onlyInvoiceList: [],

      amount: amount,
      client: this.clientSelected.id,

      type: "6",
      discount: this.creditType === 'discount',
      devolucion: this.creditType === 'return',

      currency: this.selectedInvoice.currency,

      products: this.productsList.map(p => {
        const code = p?.product?.code ?? '';
        const name = p?.product?.name ?? '';

        const description =
          (code && name) ? `${code} - ${name}` :
          code ? code :
          name ? name :
          'Producto sin descripción';

        return {
          productId: p?.product?.id ?? null,
          quantity: p.quantity ?? 0,
          price: p.unitPrice ?? 0,
          description: description,
          exemptTextId: 0
        };
      }),


      date: this.creditNoteDate + "T06:00:00.000Z",
      description: this.creditNoteDescription
    };
  }


  writeProduct(event: any) {
    const clue = event?.target?.value ?? "";
    this.getProducts(clue);
  }

  getProducts(clue: string) {
    this.productService.getProducts(clue).subscribe({
      next: (resp: ResponseObject) => {

        this.products = resp.data ?? [];
        this.filterProducts = this.products;

        if (this.filterProducts.length === 0) {
          this.changeInput(this.inputs.product, null, false, true, 'fa-xmark', null);
        } else if (this.filterProducts.length === 1) {
          const p = this.filterProducts[0];
          this.changeInput(this.inputs.product, p.name, true, false, 'fa-circle-check', p);
          this.selectedProduct = p;
        } else {
          this.changeInput(this.inputs.product, clue, false, false, 'fa-list', null);
        }
      },
      error: () => {
        this.changeInput(this.inputs.product, null, false, true, 'fa-xmark', null);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = value ?? input.value;
    input.verified = verified ?? input.verified;
    input.required = required ?? input.required;
    input.class = classIcon ?? input.class;
    input.data = data ?? input.data;
  }

  checkProduct(product: ProductResponse) {
      this.selectedProduct = product;
      this.inputs.product.value = product.code + " - " + product.name;
      this.inputs.product.verified = true;
      this.inputs.product.data = product;
  }


  calculateLineTotal() {
    this.lineTotal = (this.quantity || 0) * (this.unitPrice || 0);
  }

  addProduct() {
    if (!this.selectedProduct) {
      this.toastService.warning("Seleccione un producto");
      return;
    }

    if (this.quantity <= 0 || this.unitPrice <= 0) {
      this.toastService.warning("Cantidad y precio deben ser mayores a 0");
      return;
    }

    this.productsList.push({
      product: this.selectedProduct,
      quantity: this.quantity,
      unitPrice: this.unitPrice,
      total: this.lineTotal
    });

    this.inputs.product.value = "";
    this.inputs.product.data = null;
    this.selectedProduct = null;

    this.quantity = 0;
    this.unitPrice = 0;
    this.lineTotal = 0;
  }


  async createCreditNotePDF(creditNote: CreditNoteResponse) {
    const invoice = creditNote.invoiceResponse;
    const warehouse = creditNote.warehouse;

    const invoiceData = this.getCreditNoteInvoiceData(invoice, warehouse);

    const config = new ConfigurationInvoice(
        warehouse['nfact'],
        warehouse['fcolor'],
        warehouse['scolor'],
        warehouse['tcolor'],
        warehouse['slogan']
    );

    if (this.currentCompany) {
      const logo = this.currentCompany.companyLogo.includes("/images/company-avatar2.png")
        ? null
        : this.currentCompany.companyLogo;

      this.createService.selectTemplate(config, invoiceData, logo);
    } else {
      this.createService.selectTemplate(config, invoiceData, null);
    }
  }

  getCreditNoteInvoiceData(invoice: any, warehouse: WarehouseResponse) {

    const template = new InvoiceTemplateModel();
    template.warehouse = warehouse;
    template.type = InvoiceType.NCRE;

    template.client.name = invoice.buyerName ?? "";
    template.client.nit = invoice.buyerNit ?? "";
    template.client.address = invoice.buyerAddress ?? "";

    template.certifier.signature = invoice.signature ?? "";
    template.certifier.date = invoice.certificationDate ?? "";
    template.certifier.nit = invoice.certifierNIT ?? "";
    template.certifier.data = invoice.certifier ?? "";

    template.invoice.number = invoice.invoiceNumber ?? "";
    template.invoice.serial = invoice.serialNumber ?? "";
    template.invoice.date = invoice.date ?? "";

    if (invoice.seller?.information) {
      template.seller.name = invoice.seller.information.name ?? "";
      template.seller.city = invoice.seller.information.city ?? "";
      template.seller.state = invoice.seller.information.state ?? "";
      template.seller.street = invoice.seller.information.street1 ?? "";
      template.seller.nit = invoice.seller.nit ?? "";
    }

    template.total = invoice.total ?? 0;

    template.items = invoice.items.map(i =>
      new InvoiceItemModel(
        i.quantity.value,
        i.priceWithoutTax,
        i.description.value,
        0
      )
    );

    return template;
  }

  searching() {
    this.invoices = this.invoicesData.filter((inv) => {
      return inv.number.toString().toLowerCase().includes(this.filterWord.toLowerCase())
        || inv.series.toString().toLowerCase().includes(this.filterWord.toLowerCase())
    });
  }

}
